// extracted by mini-css-extract-plugin
export default {"header":"header-module__header--bnYxW","headerTitle":"header-module__headerTitle--w3fDL","headerLogoContainer":"header-module__headerLogoContainer--vpJsZ"};